import { _Chip as Chip } from './Chip';
import type { Meta, StoryObj } from '@storybook/react';

const meta = {
  title: 'Chip',
  component: Chip,
  args: {
    label: 'Default',
    selected: false,
    onPress: () => console.log('Pressed!'),
  },
} satisfies Meta<typeof Chip>;

export default meta;

type Story = StoryObj<typeof meta>;

export const Default: Story = {
  args: {
    label: 'Default',
  },
};

export const Selected: Story = {
  args: {
    label: 'Selected',
    selected: true,
  },
};
